import angular from 'angular';
import constants from 'app/constants';
import {
  alerts
} from 'app/components/global';
import {
  amDataService,
  docDataService,
  loaderService,
  ssDialogService,
  userService
} from 'app/services';
import controller from './attach-preparation-item-folder.controller';
import directive from './attach-preparation-item-folder.directive';


export default angular.module('app.components.advisory.auditTrail.attachPreparationItemFolder', [
  alerts,
  amDataService,
  constants,
  docDataService,
  loaderService,
  ssDialogService,
  userService,
])
  .directive('amAttachPreparationItemFolder', directive)
  .controller('AttachPreparationItemFolderController', controller)
  .name;

console.log('app.components.advisory.auditTrail.attachPreparationItemFolder created');
